var React = require('react');

function Hide (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1 8.5L8 1.5L15 8.5","stroke":"#1A1A1A","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Hide.defaultProps = {"width":"16","height":"10","viewBox":"0 0 16 10","fill":"none"};

module.exports = Hide;

Hide.default = Hide;
